import type React from "react";
import styles from "./FeedbackDetails.module.scss";

interface FeedbackProps {
	isOpen: boolean;
	onClose: () => void;
	feedback: {
		answer: string;
		score: number;
		feedback: string;
		createdAt: string;
	};
}

const parseFeedback = (feedback: string) => {
	try {
		return JSON.parse(feedback);
	} catch {
		console.error("Invalid feedback format");
		return null;
	}
};

interface CriteriaData {
	score: number;
	strengths: string[];
	areasForImprovement: string[];
}

const FeedbackDetails: React.FC<FeedbackProps> = ({
	isOpen,
	onClose,
	feedback,
}) => {
	if (!isOpen) return null;

	const parsedFeedback = parseFeedback(feedback?.feedback) as {
		overallBandScore: number;
		criteria: {
			[key: string]: {
				score: number;
				strengths: string[];
				areasForImprovement: string[];
			};
		};
		focus: {
			yourSentence: string;
			correctSentence: string;
		}[];
		modelAnswer: {
			text: string;
		};
		suggestions: string[];
	};

	console.log(parsedFeedback);

	return (
		<div className={styles.modalOverlay}>
			<div className={styles.modalContent}>
				<button type="button" className={styles.closeButton} onClick={onClose}>
					&times;
				</button>

				<div className={styles.header}>
					<h2>User&apos;s Answer</h2>
					<p className={styles.answer}>{feedback.answer}</p>
					<div className={styles.score}>Score: {feedback.score}</div>
				</div>

				<div className={styles.feedback}>
					<h3>Feedback Details</h3>
					<p>
						<strong>Overall Band Score:</strong>{" "}
						{parsedFeedback?.overallBandScore}
					</p>

					{parsedFeedback?.criteria && (
						<div className={styles.criteria}>
							{Object.entries(parsedFeedback.criteria).map(
								([criteria, data]: [string, CriteriaData]) => (
									<div key={criteria} className={styles.criteriaItem}>
										<h4>{criteria}</h4>
										<p>
											<strong>Score:</strong> {data.score}
										</p>

										<p>
											<strong>Strengths:</strong>
										</p>
										<ul>
											{data.strengths.map((item: string, index: number) => (
												<li key={item}>{item}</li>
											))}
										</ul>

										<p>
											<strong>Areas for Improvement:</strong>
										</p>
										<ul>
											{data.areasForImprovement.map((item: string) => (
												<li key={item}>{item}</li>
											))}
										</ul>
									</div>
								),
							)}
						</div>
					)}

					{parsedFeedback?.focus && (
						<div className={styles.criteria}>
							<h4>Focus on this:</h4>
							{parsedFeedback?.focus?.map(
								(
									item: { yourSentence: string; correctSentence: string },
									index: number,
								) => (
									<div
										key={item.correctSentence}
										className={styles.criteriaItem}
									>
										<p>
											<strong>You said:</strong> {item.yourSentence}
										</p>
										<p>
											<strong>Improved version:</strong> {item.correctSentence}
										</p>
										{index !== parsedFeedback.focus.length - 1 && <hr />}
									</div>
								),
							)}
						</div>
					)}

					{parsedFeedback?.modelAnswer && (
						<div className={styles.modelAnswer}>
							<h4>Model Answer:</h4>
							<p>{parsedFeedback.modelAnswer.text}</p>
						</div>
					)}

					{parsedFeedback?.suggestions && (
						<div className={styles.suggestions}>
							<h4>Suggestions:</h4>
							<ul>
								{parsedFeedback.suggestions.map((suggestion: string) => (
									<li key={suggestion}>{suggestion}</li>
								))}
							</ul>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default FeedbackDetails;
